import React from "react";
import { useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import { AnimatePresence, motion } from "framer-motion";
import logo from "../images/favicon_256.png";

export const WelcomeScreen = (props) => {
  const currentTheme = useSelector((state) => state.currentTheme);
  const welcomeScreen = useSelector((state) => state.welcomeScreen);

  if (!welcomeScreen.isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="welcome-screen-layout"
        key="modal"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1.5 }}
      >
        <div className="welcome-screen">
          <div className="logo">
            <img src={logo} />
          </div>
          <div className="title">
            <span>Intelligence</span>
          </div>
          <div className="loader">
            <Loader />
          </div>
        </div>
        <style>
          {`
                        .welcome-screen-layout
                        {                        
                            width: 100vw;
                            min-height: 100dvh;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            position: fixed;
                            z-index: 10030;
                            inset: 0;
                            padding: 16px;
                            box-sizing: border-box;
                        }

                        .welcome-screen
                        {
                            width: 25%;
                            height: 25%;
                            padding: 32px 32px;
                            border: 1px solid ${currentTheme.componentBorderColor};
                            border-radius: 10px;
                            background-image: linear-gradient(to right, ${currentTheme.touchColor},  ${currentTheme.touchColor});
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                        }

                        .welcome-screen .logo
                        {
                            flex-grow: 7;
                            overflow: hidden;
                        }

                        .welcome-screen .logo img
                        {
                            height: 70%;
                        }

                        .welcome-screen .title
                        {
                            flex-grow: 2;
                            font-size: 1.6rem;
                            font-weight: 700;
                            color: white;
                        }

                        .welcome-screen .loader
                        {
                            flex-grow: 1;
                        }

                        .welcome-screen .loader .k-loader-canvas
                        {
                            color: white;
                        }

                        @media (max-width: 1024px)
                        {
                            .welcome-screen
                            {
                                width: min(360px, 100%);
                                min-height: 260px;
                                height: auto;
                                padding: 24px;
                                box-sizing: border-box;
                            }

                            .welcome-screen .logo img
                            {
                                width: min(150px, 100%);
                                height: auto;
                            }

                            .welcome-screen .title
                            {
                                font-size: 1.35rem;
                                text-align: center;
                            }
                        }
                    `}
        </style>
      </motion.div>
    </AnimatePresence>
  );
};
